// extracted by mini-css-extract-plugin
export default {"notificationContainer":"notification_notificationContainer__0gn7O","active":"notification_active__y5j4o"};